import type { TMatchingResponse } from '@vlabs/monokit/entities/matcher/types/types';

import type { TTransformedSearchResult } from '../model/types';

export const mapMatchResults = (
  matchResults: TMatchingResponse[] | undefined,
  order = 'similarity',
): TTransformedSearchResult[] => {
  if (!matchResults || matchResults.length === 0) {
    return [];
  }

  const mapped = matchResults
    .flatMap(({ matches, reference }) => matches.flatMap((match) => (match.result ?? []).map((original) => ({
      ...original.face,
      ...original.event,
      similarity: original.similarity,
      reference,
    })))) as unknown as TTransformedSearchResult[];
  if (order !== 'similarity') return mapped;

  return mapped.sort((a, b) => b.similarity - a.similarity);
};
